
import {
    Button,
    Typography,
    useMediaQuery,
    Grid,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
    Tooltip
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useTheme } from '@mui/material/styles';

export const CommentsGrid = ({
    onClose,
    open,
    commentList
}: any) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleCommentText = (props: any) => {
        const { row } = props;
        return (
            <Tooltip title={row.comment}>
                <Typography variant="subtitle1"
                    sx={{ width: '100%', overflowY: 'scroll', whiteSpace: 'inherit' }}
                >{row.comment}</Typography>
            </Tooltip>
        )
    }

    const handleUserFrom = (props: any) => {
        const { row } = props;
        return (
            <Tooltip title={row.userType === 1 ? 'Eurofins' : commentList?.clientName}>
                <Typography variant="subtitle1"
                    sx={{ width: '100%', overflowY: 'scroll', whiteSpace: 'inherit' }}
                >{row.userType === 1 ? 'Eurofins' : commentList?.clientName}</Typography>
            </Tooltip>
        )
    }

    const commentColumns = [
        {
            field: 'userName',
            headerName: 'User',
            minWidth: 150
        },
        {
            field: 'userFrom',
            headerName: 'User From',
            minWidth: 150,
            renderCell: handleUserFrom
        },
        {
            field: 'comment',
            headerName: 'Comment',
            minWidth: 340,
            renderCell: handleCommentText
        },
        {
            field: 'quoteStatusName',
            headerName: 'Status',
            minWidth: 150
        }
    ];

    return (
        <Dialog
            onClose={onClose}
            open={open}
            fullScreen={fullScreen}
            fullWidth={true}
            sx={{
                padding: 10,
                '.MuiPaper-root': {
                    maxWidth: '800px'
                }
            }}
        >
            <DialogTitle id="customized-dialog-title2">
                <Typography variant="h6">
                    Comments
                </Typography>
            </DialogTitle>
            <DialogContent style={{ padding: 28 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 0 }}>
                        <DataGrid
                            autoHeight
                            disableSelectionOnClick
                            sx={{
                                '.MuiDataGrid-columnHeaders': {
                                    backgroundColor: '#003883',
                                    color: '#fff'
                                },
                                '.MuiDataGrid-menuIcon .MuiSvgIcon-root': {
                                    color: '#fff'
                                },
                                '.MuiDataGrid-iconButtonContainer .MuiSvgIcon-root': {
                                    color: '#fff'
                                },
                                "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                                    outline: "none !important",
                                }
                            }}
                            columns={commentColumns}
                            rows={commentList?.quotesComments || []}
                            pageSize={10}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="error" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog >
    );
}
